import AvailabilityDisclaimer from '@app/components/common/product/AvailabilityDisclaimer';
import GstDisclaimer from '../../../common/product/GstDisclaimer';
import PropTypes from 'prop-types';
import { isPDP, isSearchPage, isCategoryPage } from '@app/utils';

const ProductDisclaimers = ({
  className = '',
  disclaimerClassName = '',
  isQuantityMergeEnabled,
  taxDisclaimerMessageFooter
}) => {
  const arelegalDisclaimersAvailable =
    !!taxDisclaimerMessageFooter || !isQuantityMergeEnabled;
  const isPdpPage = isPDP();
  const isModernizedSearchPage = isSearchPage();
  const isPlp = isCategoryPage();
  const displayAvailabilityDisclaimer =
    !isQuantityMergeEnabled && !isPdpPage && !isModernizedSearchPage && !isPlp;

  const getGSTDisclaimer = () => {
    return (
      <p>
        <GstDisclaimer
          className={disclaimerClassName}
          taxMessage={taxDisclaimerMessageFooter}
          numberOfDaggers={displayAvailabilityDisclaimer ? 2 : 1}
        />
      </p>
    );
  };
  return (
    arelegalDisclaimersAvailable && (
      <section className={className}>
        {displayAvailabilityDisclaimer && (
          <p className="mb-0">
            <AvailabilityDisclaimer
              className={disclaimerClassName}
              numberOfDaggers={1}
            />
          </p>
        )}
        {!!taxDisclaimerMessageFooter && getGSTDisclaimer()}
      </section>
    )
  );
};

export default ProductDisclaimers;

ProductDisclaimers.propTypes = {
  className: PropTypes.string,
  disclaimerClassName: PropTypes.string,
  taxDisclaimerMessageFooter: PropTypes.string,
  isQuantityMergeEnabled: PropTypes.bool
};
